// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__hDKaT","hidden":"Pagination_hidden__Of8np","page":"Pagination_page__iz-Ec","active":"Pagination_active__pziWr"};